import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavMobileRoutingModule } from './nav-mobile-routing.module';
import { NavMobileComponent } from './nav-mobile.component';
import { MobileModelosComponent } from './mobile-modelos/mobile-modelos.component';
import { MobileNovedadesComponent } from './mobile-novedades/mobile-novedades.component';
import { MobileServiciosComponent } from './mobile-servicios/mobile-servicios.component';


@NgModule({
  exports:[
    NavMobileComponent
  ],
  declarations: [
    NavMobileComponent,
    MobileModelosComponent,
    MobileNovedadesComponent,
    MobileServiciosComponent
  ],
  imports: [
    CommonModule,
    NavMobileRoutingModule
  ]
})
export class NavMobileModule { }
